import styled from 'styled-components'

const Votes = styled.span`
	align-items: center;
	display: inline-flex;

	color: rgba(${props => props.invert ? '255, 255, 255' : '0, 0, 0'}, ${props => props.votes >= 3 ? props.votes / 15 : 0.2});
	font-family: TechnaSans, ${props => props.theme.fontDefault};
	font-size: 1.2rem;
	font-weight: 400;
	margin-right: ${props => props.hasPeriodVotes ? '0.75rem' : '0.5rem'};
	min-width: ${props => props.hasPeriodVotes ? '30px' : '20px'};

	${props => props.votes <= 0 && `
		color: ${props.invert ? '#555' : props.theme.backgroundConcrete};
	`}
`

export const PeriodVotes = styled.span`
	font-size: 0.8rem;
	font-weight: bold;
	margin-left: 0.15rem;

	${props => props.periodVotes > 0 ? `
		color: ${props.theme.green};
	` : ''}

	${props => props.periodVotes < 0 ? `
		color: ${props.theme.red};
	` : ''}

	${props => props.periodVotes === 0 ? `
		color: ${props.theme.backgroundConcrete};
	` : ''}
`

export default Votes
